/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFormik } from 'formik';
import {
    Button,
    Field,
    makeStyles,
    mergeClasses,
    Textarea,
} from '@fluentui/react-components';
import { Column, Row } from '../common';
import { useAccountState } from '../../redux/reducers/accountReducer';
import { Note, useInitialValues } from '../../data/types';
import { useCommonStyles } from '../common/Styles/commonStyles';
import { useValidation } from '../../data/types/validation';

const useStyles = makeStyles({
    root: {},
});
export type CaseNoteFormProps = {
    className?: string;
    submitNote?: (note: Note) => Promise<void>;
    caseId?: string;
    vertical?: boolean;
    required?: boolean;
    title?: string;
};
export const CaseNoteForm = (props: CaseNoteFormProps) => {
    const { className, submitNote, caseId, vertical, required = true, title = 'Add Note' } = props;

    //Hooks
    const { primaryAccount } = useAccountState();
    const initValues = useInitialValues();
    const { validateCaseNote } = useValidation();

    //Styles
    const commonStyles = useCommonStyles();
    const styles = useStyles();
    const formClasses = mergeClasses(styles.root, className);

    //Form
    const noteForm = useFormik<Note>({
        initialValues: initValues.caseNote(caseId as string),
        onSubmit: async (values, { resetForm }) => {
            const note = values as Note;
            if (!!note.text) {
                note.lifecycle = {
                    createdOn: new Date(),
                    createdBy: primaryAccount?.user.userId,
                };
                resetForm({ values: initValues.caseNote(caseId as string) });

                !!submitNote && (await submitNote(values));
            } else {
                resetForm({ values: initValues.caseNote(caseId as string) });
            }
        },
        validationSchema: validateCaseNote.schema,
    });

    //UI Events
    const addNote = (e: any) => {
        e.stopPropagation();

        noteForm.submitForm();
    };

    const columns = (
        <>
            <Column>
                <Field
                    className={commonStyles.text.field}
                    label={title}
                    required={required}
                    hint={`${noteForm.values.text.length} / ${validateCaseNote.text.maxLength}`}
                >
                    <Textarea
                        name='text'
                        tabIndex={1}
                        rows={2}
                        value={noteForm?.values.text}
                        onChange={noteForm?.handleChange}
                        placeholder='Note text'
                        data-testid='case-note-input'
                        maxLength={validateCaseNote.text.maxLength}
                    />
                </Field>
            </Column>
            <Column vAlign='middle' width='auto' align='right'>
                <Button
                    onClick={addNote}
                    disabled={!noteForm?.dirty || !noteForm?.isValid}
                    data-testid='case-note-add-button'
                >
                    Add Note
                </Button>
            </Column>
        </>
    );

    return (
        <div className={formClasses}>
            {!!vertical ? (
                <Column gap='medium'>{columns}</Column>
            ) : (
                <Row gap='medium'>{columns}</Row>
            )}
        </div>
    );
};
